import { NotificationConfig } from '~/actions/triggers/types';
import { hexToRgb } from '~/helpers/converters/hexToRgb';

export const notificationDesktopStyles = (iterator: number, prefix: string, configuration: NotificationConfig) => `
.${prefix}notification_with_wheel_desktop_${iterator} {
  max-width: 712px;
  width: 712px;
  min-height: 544px;
  height: 544px;
  overflow: initial !important;
  left: 544px !important;
  animation-name: ${prefix}notification_with_wheel_desktop;
  animation-duration: .5s;
}

@keyframes ${prefix}notification_with_wheel_desktop {
  from {
    left: -280px;
    animation-timing-function: linear;
  }

  to {
    left: 280px
    animation-timing-function: linear;
  }
}

.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body {
  max-width: 328px;
  width: 328px;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  padding-right: 50px !important;
}

.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body > .${prefix}notification__title,
.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body > .${prefix}notification__message,
.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body > .${prefix}notification__coupon,
.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body >.${prefix}notification__button {
  text-align: center !important;
  width: 328px !important;
  min-width: 328px !important;
}

.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body >
.${prefix}notification__title {
  font-weight: 700;
  font-size: 40px;
  line-height: 42px;
  margin-bottom: 24px;
}

.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body >
.${prefix}notification__message {
  font-weight: 400;
  color: #808080;
  font-size: 22px;
  line-height: 26px;
}

.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body >
.${prefix}notification__button {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  height: 56px;
}

.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body >
.${prefix}notification__coupon {
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  height: 56px;
  outline: none;
  border-radius: 8px;
  border: ${
  configuration?.couponWithBorder
    ? `${configuration?.couponBorderWidth}px dashed ${hexToRgb(
      configuration?.couponBorderColor,
      configuration?.couponBorderOpacity
    )}`
    : 'none'
};
}

.${prefix}notification_with_wheel_desktop_${iterator} > .${prefix}notification__body >
.${prefix}notification__coupon > .${prefix}notification__coupon-text {
  font-weight: 400;
  font-size: 24px;
}
`;
